module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?76fb4d285d3e5410e4cebec25c85b805";